var map = {
	"./logo": 5,
	"./logo.png": 5,
	"./person-placeholder": 6,
	"./person-placeholder.jpg": 6,
	"./teacher": 7,
	"./teacher.jpg": 7,
	"./teacher2": 8,
	"./teacher2.jpg": 8,
	"./teacherHome": 9,
	"./teacherHome.jpg": 9
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;